import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';

import { getResponseMessage } from '../../../../../../utils/utils';
import { getProductById } from '../../../../../../crud/product.crud';
import { useFormatMessage } from '../../../../../../hooks';
import { IProduct } from '../../../../../../interfaces/product';

export function useGetProduct() {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState<IProduct | null>(null);
  const fm = useFormatMessage();

  const fetchProduct = useCallback(async (id: number) => {
    setLoading(true);
    getProductById(id)
      .then(res => {
        setProduct(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { fetchProduct, product, loading };
}
